import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatToolbarModule} from '@angular/material/toolbar';
import {RouterModule} from '@angular/router';
import {LandingRoutingModule} from '@app/landing/landing-routing.module';
import {NgxStripeModule} from 'ngx-stripe';
import {ContactComponent} from './contact/contact.component';
import {FooterComponent} from './footer/footer.component';
import {LandingComponent} from './landing/landing.component';
import {PricingComponent} from './pricing/pricing.component';
import {PrivacyComponent} from './privacy/privacy.component';
import {TermsComponent} from './terms/terms.component';
import {ToolbarComponent} from './toolbar/toolbar.component';
import {TryBlockComponent} from './try-block/try-block.component';
import {UpgradeDialogComponent} from './upgrade-dialog/upgrade-dialog.component';
import {UpgradeComponent} from './upgrade/upgrade.component';

@NgModule({
    exports: [ToolbarComponent, TryBlockComponent, FooterComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatInputModule,
        FormsModule,
        MatListModule,
        MatToolbarModule,
        RouterModule,
        ReactiveFormsModule,
        NgxStripeModule,
        MatIconModule,
        MatSelectModule,
        LandingRoutingModule,
        MatAutocompleteModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatExpansionModule,
        MatSliderModule,
        MatRadioModule,
        MatDialogModule,
        LandingComponent,
        PricingComponent,
        UpgradeComponent,
        ToolbarComponent,
        FooterComponent,
        TryBlockComponent,
        ContactComponent,
        TermsComponent,
        PrivacyComponent,
        UpgradeDialogComponent,
    ],
})
export class LandingModule {}
